import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';
import * as React from 'react';
import { withClassname } from '@components/hoc/withClassname';
import { WeeksForm } from '@modules/hr-templates/weeks/WeeksForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const weeksUrl = '/metropolis/api/hr/workplan/calendar/week';
export const weeksLabel = 'Personalistika - týdenní šablony';
export const weeksPath = '/hr/templates/weeks';
export const weeksGridName = 'WeeksGrid';
export const WeeksGrid = compose(
  withRouter,
  setDisplayName(weeksGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: weeksLabel }]),
  withColumns(Agenda.WEEKS),
  withProps(({ columns }) => ({
    name: weeksGridName,
    url: weeksUrl,
    Form: WeeksForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      version: 7,
      ActionBar: () => <ColumnManager agenda={Agenda.WEEKS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-templates/weeks/WeeksGrid.tsx